import React, { Component } from 'react'
import { Link } from 'react-router-dom'
//import { Navbar } from 'react-bootstrap';
import '../App.css';
class Footer extends Component {
  render() {
    return (
		<footer>
			<div className="container">
			<div className="footsign">@ {new Date().getFullYear().toString()} Sims solutions - All rights reserved </div>
			</div>
		</footer>
    )
  }
}

export default Footer
